/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable arrow-body-style */
/* eslint-disable arrow-parens */
/* eslint-disable no-confusing-arrow, function-paren-newline */
import React, { useCallback, useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import { FiBell } from 'react-icons/fi';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'
import moment from 'moment'
import { Col, FormGroup, Input, Row } from 'reactstrap'
import orderApi from '_api/order'
import userApi from '_api/user'
import { useModal } from '_hooks/useModal'
import TableHeaderWithSort from '_components/TableHeaderWithSort'
import ModalDetailOrder from '_pages/Event/components/ModalDetailOrder'
import ModalMessage from '_pages/Event/components/ModalMessage'
import ModalPaymentScreen from '_pages/Event/components/ModalPaymentScreen'
import ModalWarning from '_pages/Event/components/ModalWarning'
import ModalRefundOrder from '_pages/Event/components/ModalRefundOrder'
import { updateDeliveryCombinedPayment } from '_redux/modules/delivery'
import {
  getListCombinedPayment,
  updateOrderCombinedPayment,
  updateOrderStatus,
  updateOrderStatusOfOrderInAllEventAndOrder,
  getPackingListEvents,
  getEventAndOrder
} from '_redux/modules/event'
import {
  BUYER_CANCELED,
  BUYER_COLLECTED,
  BUYER_PAID,
  BUYER_REFUNDED,
  BUYER_UNPAID,
  HOST_ORDER_CANCELED,
  HOST_ORDER_COLLECTED,
  HOST_ORDER_UNPAID,
  HOST_ORDER_VERIFIED,
  HOST_ORDER_SUBMITTED_UNPAID,
  HOST_ORDER_SUBMITTED_VERIFIED,
  HOST_ORDER_SUBMITTED_COLLECTED,
  HOST_ORDER_REFUNDED,
  PAYMENT_METHOD_HIT_PAY,
} from '_utils/constant'
import { handleDataOrder, handleDataOrderByPercentage } from '_utils/function'
import { formatNumberEng } from '_utils/formatNumber'
import { getUserInfo, getRemindPaymentMessage, setRemindPaymentMessage } from '_utils/localData'
import RemindPaymentModel from '_pages/Event/components/RemindPaymentModel'
import HitPayRibbon from '_components/HitPayRibon'
import { Tabs, TabsList, TabsTrigger } from './Tabs'
// eslint-disable-next-line no-unused-vars
function OrderList({ listOrder, setSorting, setTimeRender, pagedEvents, isConsolidate, isHeaderSelectAll, setIsHeaderSelectAll, orderTab, setOrderTab, consolidatedEventIds, excludeCancelled, setExcludeCancelled }) {
  const { addToast } = useToasts()
  const host = getUserInfo()
  const dispatch = useDispatch()
  const data = Array.isArray(listOrder) ? listOrder : []
  const { pathname } = useLocation()

  const modalMessage = useModal(false)
  const modalPaymentScreen = useModal(false)
  const modalDetailOrder = useModal(false)
  const modalRemindPayment = useModal(false)
  const modalWarning = useModal(false)
  const modalRefundOrder = useModal(false)
  const [selectedRefundOrder, setSelectedRefundOrder] = useState(null)
  const [selectedOrders, setSelectedOrders] = useState([])
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false)
  const MAX_SELECTION = 5
  const [expandedRows, setExpandedRows] = useState(new Set())

  const now = Date.now() / 1000;
  const { eventAndOrderById, listCombinedPayments, productList, /* listEventAndDelivery  */ } = useSelector(
    (state) => state.event
  )
  const groupId = useMemo(() => {
    return pagedEvents?.length ? pagedEvents[0]?.groupId : null
  }, [pagedEvents[0]?.groupId])
  const checkIsAmendOrder = useCallback((order) => {
    const isCloseOrder =
      pagedEvents?.find(event => event.id === order.eid)?.closingTimestamp < now;
    return order.status === HOST_ORDER_UNPAID && !isCloseOrder;
  }, [pagedEvents, now]);

  const groupedOrdersByUName = useMemo(() => {
    if (!isConsolidate) return []
    const map = new Map()
    for (const order of data) {
      const key = order.uName || 'Unknown'
      if (!map.has(key)) map.set(key, [])
      map.get(key).push(order)
    }

    return Array.from(map.entries())
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([uName, orders]) => ({ [uName]: orders }))
  }, [isConsolidate, data])

  const headers = [
    // {
    //   name: '',
    //   field: '',
    //   type: 'string',
    //   className: 'col-auto',
    //   sortable: false,
    // },
    {
      name: 'Name',
      field: 'uName',
      type: 'string',
      className: 'col col-auto',
      sortable: true,
    },
    {
      name: 'Mobile',
      field: 'uPhone',
      className: 'col col-auto',
      type: 'string',
      sortable: true,
    },
    {
      name: 'Event',
      field: 'eTitle',
      type: 'string',
      className: 'col col-auto',
      sortable: true,
    },
    {
      name: 'Date',
      field: 'createdAt',
      type: 'number',
      className: 'col col-auto',
      sortable: true,
    },
    {
      name: 'Purchase',
      field: '',
      type: 'string',
      className: 'col col-auto',
      sortable: true,
    },
    {
      name: 'Price',
      field: '',
      type: 'number',
      className: 'col col-auto text-center',
      sortable: true,
    },
    {
      name: 'Event Status',
      field: '',
      type: 'number',
      className: 'col col-auto text-center',
      sortable: true,
    },
    {
      name: 'Payment Status',
      field: 'buyerStatus',
      type: 'number',
      className: 'col col-auto text-center',
      sortable: true,
    },
    {
      name: 'Verified',
      field: 'status',
      type: 'number',
      className: 'col col-auto text-center',
      sortable: true,
    },
  ]
  const MAX_PREVIEW = 2
  const [loading, setLoading] = useState(true)
  const [dataModal, setDataModal] = useState({})
  const [dataModalDetailOrder, setDataModalDetailOrder] = useState()
  const [selectedDetailOrder, setSelectedDetailOrder] = useState(null)
  const [remindMessage, setRemindMessage] = useState(null)

  useEffect(() => {
    if (selectedDetailOrder && Array.isArray(listOrder)) {
      const updated = listOrder.find((o) => o.ref === selectedDetailOrder.ref)
      if (updated) {
        setSelectedDetailOrder(updated)
      }
    }
  }, [listOrder])

  useEffect(() => {
    if (selectedDetailOrder?.eid) {
      const currentEvent = eventAndOrderById?.find(
        (item) => item.id === selectedDetailOrder.eid
      )
      if (!currentEvent || !currentEvent.products?.length) {
        dispatch(getEventAndOrder(selectedDetailOrder.eid))
      }
    }
  }, [selectedDetailOrder?.eid, dispatch, eventAndOrderById])

  const getRemindMessage = async () => {
    const message = getRemindPaymentMessage()

    if (message) {
      setRemindMessage(message)
    } else {
      const { msgResp } = await userApi.getRemindPaymentMessage()
      setRemindPaymentMessage(msgResp)
      setRemindMessage(msgResp)
    }
  }

  const tableHeaders = useMemo(() => {
    if (!isConsolidate) return headers
    return headers.filter((h) =>
      !['status', 'createdAt'].includes(h.field) &&
      h.name !== 'Event Status'
    )
  }, [isConsolidate, headers])

  const initListOrder = async (_data) => {
    const listCombinedPaymentRef = []
    setLoading(true)
    _data?.forEach(async (element) => {
      const { combinedPaymentRef = '' } = element
      if (!listCombinedPaymentRef.includes(combinedPaymentRef)) {
        if (combinedPaymentRef) {
          listCombinedPaymentRef.push(combinedPaymentRef)
        }
      }
    })
    if (listCombinedPaymentRef.length) {
      await dispatch(getListCombinedPayment(listCombinedPaymentRef))
    }
    setLoading(false)
  }

  useEffect(() => {
    initListOrder(listOrder)
    getRemindMessage()
  }, [pathname])

  useEffect(() => {
    if (selectedOrders.length === 0) setIsHeaderSelectAll(false)
  }, [selectedOrders.length])

  const updateOrderStatusAPI = async (_ref, _data, _eid) => {
    dispatch(
      updateOrderStatusOfOrderInAllEventAndOrder(_eid, _ref, _data.status, _data.buyerStatus)
    )
    await orderApi.updateOrderStatusAndBuyerStatus(_ref, { status: _data.status })
  }

  const updateOrderStatusAndBuyerStatusAPI = async (_ref, _data, _eid) => {
    dispatch(
      updateOrderStatusOfOrderInAllEventAndOrder(_eid, _ref, _data.status, _data.buyerStatus)
    )
    await orderApi.updateOrderStatusAndBuyerStatus(_ref, _data)
  }

  const updateOrderCombinedPaymentAPI = async (_data) => {
    dispatch(updateOrderCombinedPayment(_data.combinedPaymentRef, _data.status, _data.placerStatus))
    dispatch(
      updateDeliveryCombinedPayment(_data.combinedPaymentRef, _data.status, _data.placerStatus)
    )
    await orderApi.updateInvoicesStatus(_data)
  }

  const getStatusText = (status) => {
    switch (status) {
      case HOST_ORDER_CANCELED: return 'Cancelled'
      case HOST_ORDER_UNPAID: return 'Unpaid'
      case HOST_ORDER_VERIFIED: return 'Verified'
      case HOST_ORDER_COLLECTED: return 'Collected'
      case HOST_ORDER_SUBMITTED_UNPAID: return 'Submitted & Unpaid'
      case HOST_ORDER_SUBMITTED_VERIFIED: return 'Submitted & Verified'
      case HOST_ORDER_SUBMITTED_COLLECTED: return 'Submitted & Collected'
      case HOST_ORDER_REFUNDED: return 'Refunded'
      default: return 'Unknown'
    }
  }
  const getConsolidatedPaymentStatus = useCallback((orders) => {
    if (!orders?.length) return '—'
    const countNotPaid = orders.filter(o => o.buyerStatus === BUYER_UNPAID).reduce((sum, o) => sum + o.totalPricePerOrder, 0)
    if (countNotPaid > 0) return `Not Paid ($${countNotPaid})`

    const allCancelled = orders.every(o => o.buyerStatus === BUYER_CANCELED)
    if (allCancelled) return 'Cancel'

    const allPaidOrVerifiedOrCollected = orders.every(o =>
      o.buyerStatus === BUYER_PAID ||
      o.status === HOST_ORDER_VERIFIED ||
      o.status === HOST_ORDER_SUBMITTED_VERIFIED ||
      o.buyerStatus === BUYER_COLLECTED ||
      o.status === HOST_ORDER_COLLECTED ||
      o.status === HOST_ORDER_SUBMITTED_COLLECTED
    )

    if (allPaidOrVerifiedOrCollected) {
      const hasPaidButNotVerified = orders.some(o =>
        o.buyerStatus === BUYER_PAID &&
        (o.status === HOST_ORDER_UNPAID || o.status === HOST_ORDER_SUBMITTED_UNPAID)
      )

      if (hasPaidButNotVerified) return 'Paid'

      return 'Paid & Verified'
    }

    return '—'
  }, [])

  const isOrderSelected = (order) => {
    return selectedOrders.some(item => item.ref === order.ref)
  }
  // eslint-disable-next-line no-unused-vars
  const handleCheckboxChange = (order, isChecked) => {
    if (isChecked) {
      if (!isOrderSelected(order) && selectedOrders.length >= MAX_SELECTION) {
        return
      }
      if (selectedOrders.length === 0) {
        setSelectedOrders([order])
      } else {
        const firstSelectedStatus = selectedOrders[0].status
        if (order.status === firstSelectedStatus) {
          setSelectedOrders((prev) =>
            prev.some((o) => o.ref === order.ref) ? prev : [...prev, order]
          )
        } else {
          addToast(
            `Can only select orders with same status. Current selection has status: ${getStatusText(firstSelectedStatus)}`,
            { appearance: 'warning', autoDismiss: true }
          )
        }
      }
    } else {
      setSelectedOrders(prev => prev.filter(item => item.ref !== order.ref))
    }
  }
  // eslint-disable-next-line no-unused-vars
  const handleSelectAll = (isChecked) => {
    if (isChecked && selectedOrders.length > 0) {
      const targetStatus = selectedOrders[0].status
      const sameStatusOrders = data.filter((order) => order.status === targetStatus)

      const alreadySelectedRefs = new Set(selectedOrders.map((o) => o.ref))
      const candidates = sameStatusOrders.filter((o) => !alreadySelectedRefs.has(o.ref))

      const availableSlots = MAX_SELECTION - selectedOrders.length
      if (availableSlots <= 0) {
        setIsHeaderSelectAll(true)
        return
      }

      if (candidates.length > availableSlots) {
        const toAdd = candidates.slice(0, availableSlots)
        setSelectedOrders((prev) => [...prev, ...toAdd])

        setIsHeaderSelectAll(true)
      } else {
        setSelectedOrders((prev) => [...prev, ...candidates])
        setIsHeaderSelectAll(true)
      }
    } else if (isChecked && selectedOrders.length === 0) {
      addToast('Please select at least one order first to determine the status filter', {
        appearance: 'warning',
        autoDismiss: true,
      })
      setIsHeaderSelectAll(false)
    } else {
      setSelectedOrders([])
      setIsHeaderSelectAll(false)
    }
  }

  const handleConfirmRefund = useCallback(
    async (refunds, selectedRefundOrders) => {
      try {
        await orderApi.refundHitPayOrder({ refunds })
        selectedRefundOrders.forEach((o) => {
          const orderEid = o.eid || pagedEvents?.[0]?.id
          if (orderEid) {
            dispatch(
              updateOrderStatusOfOrderInAllEventAndOrder(
                orderEid,
                o.ref,
                HOST_ORDER_REFUNDED,
                o.buyerStatus
              )
            )
          }
        })
        if (setTimeRender) setTimeRender((prevState) => prevState + 1)
        addToast('Refund request processed successfully', {
          appearance: 'success',
          autoDismiss: true,
        })
      } catch (error) {
        const { msgResp } = error || {}
        addToast(msgResp || 'Failed to process refund', {
          appearance: 'error',
          autoDismiss: true,
        })
        throw error
      }
    },
    [dispatch, pagedEvents, setTimeRender, addToast]
  )

  const onChangeSelect = async (e, ref, _status, _buyerStatus, _combinedPaymentRef, _eid, order) => {
    const newStatus = Number(e.target.value)

    if (newStatus === HOST_ORDER_REFUNDED) {
      e.target.value = _status
      const targetOrder =
        order ||
        data?.find((o) => o.ref === ref) || {
          ref,
          status: _status,
          buyerStatus: _buyerStatus,
          combinedPaymentRef: _combinedPaymentRef,
          eid: _eid,
        }
      setSelectedRefundOrder(targetOrder)
      modalRefundOrder.openModal()
      return
    }

    try {
      const isSelectedOrder = selectedOrders.some(orderItem => orderItem.ref === ref)
      const ordersToUpdate = isSelectedOrder ? selectedOrders : [{ ref, status: _status, buyerStatus: _buyerStatus, combinedPaymentRef: _combinedPaymentRef, eid: _eid }]

      // Always show full screen loading
      setIsUpdatingStatus(true)

      const updatePromises = ordersToUpdate.map(async (orderItem) => {
        const isUnpaidToVerifiedOrCollected =
          (orderItem.status === HOST_ORDER_UNPAID || orderItem.status === HOST_ORDER_SUBMITTED_UNPAID) &&
          (newStatus === HOST_ORDER_VERIFIED || newStatus === HOST_ORDER_SUBMITTED_VERIFIED || newStatus === HOST_ORDER_COLLECTED || newStatus === HOST_ORDER_SUBMITTED_COLLECTED)

        const isCancelPaidOrder =
          orderItem.status !== HOST_ORDER_CANCELED &&
          newStatus === HOST_ORDER_CANCELED &&
          orderItem.buyerStatus > BUYER_UNPAID

        const isRestoreCanceledOrder =
          orderItem.status === HOST_ORDER_CANCELED &&
          newStatus !== HOST_ORDER_CANCELED &&
          orderItem.buyerStatus === BUYER_REFUNDED

        if (isUnpaidToVerifiedOrCollected) {
          const _data = { status: newStatus, buyerStatus: BUYER_PAID }
          await updateOrderStatusAndBuyerStatusAPI(order.ref, _data, order.eid)
          return
        }

        if (isCancelPaidOrder) {
          if (order.combinedPaymentRef) {
            const _data = {
              combinedPaymentRef: order.combinedPaymentRef,
              status: HOST_ORDER_CANCELED,
              placerStatus: BUYER_REFUNDED,
            }
            await updateOrderCombinedPaymentAPI(_data)
          } else {
            const _data = { status: newStatus, buyerStatus: BUYER_REFUNDED }
            await updateOrderStatusAndBuyerStatusAPI(order.ref, _data, order.eid)
          }
          return
        }

        if (isRestoreCanceledOrder) {
          const _data = { status: newStatus, buyerStatus: BUYER_PAID }
          await updateOrderStatusAndBuyerStatusAPI(order.ref, _data, order.eid)
          return
        }

        const _data = { status: newStatus, buyerStatus: order.buyerStatus }
        await updateOrderStatusAPI(order.ref, _data, order.eid)
      })

      const results = await Promise.allSettled(updatePromises)

      const failed = results.filter(r => r.status === 'rejected')
      if (failed.length > 0) {
        addToast(`${failed.length} orders failed to update`, {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 3000
        })
      } else {
        addToast(`Successfully updated ${ordersToUpdate.length} order${ordersToUpdate.length > 1 ? 's' : ''}`, {
          appearance: 'success',
          autoDismiss: true,
          autoDismissTimeout: 3000
        })
        setTimeRender((prevState) => prevState + 1)
        if (isConsolidate && pagedEvents?.length) {
          await dispatch(getPackingListEvents(consolidatedEventIds))
        }
      }
    } catch (error) {
      const { msgResp } = error
      addToast(msgResp, {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 3000
      })
    } finally {
      setIsUpdatingStatus(false)
      setSelectedOrders([])
    }
  }

  const openPaymentScreen = (e, order) => {
    e.preventDefault()

    const { combinedPaymentRef = '' } = order
    let listCombinedOrder = []
    let listCombinedDelivery = []

    if (combinedPaymentRef) {
      const exitCombinedPayment = listCombinedPayments?.findIndex(
        (item) => item.combinedPaymentRef === combinedPaymentRef
      )

      if (exitCombinedPayment !== -1) {
        const { orderCombinedPayment, deliveryCombinedPayment } =
          listCombinedPayments[exitCombinedPayment]

        orderCombinedPayment
          .forEach((element) => {
            const { eid, ref: elementRef } = element
            const { orders, adminCost, discount, deliveryCost, productIdList, isPercentage = false, orderDiscountEnabled, orderDiscount } =
              eventAndOrderById.find((item) => item.id === eid) || {}
            const { listOrder: otherListOrder } = isPercentage ? handleDataOrderByPercentage(
              orders,
              adminCost,
              discount,
              deliveryCost,
              productIdList,
              orderDiscountEnabled,
              orderDiscount
            ) : handleDataOrder(orders,
              adminCost,
              discount,
              deliveryCost,
              productIdList,
              orderDiscountEnabled,
              orderDiscount
            )

            const otherOrder = otherListOrder.find((item) => item.ref === elementRef)
            listCombinedOrder = [...listCombinedOrder, otherOrder]
          })
        listCombinedDelivery = [...deliveryCombinedPayment]
      }
    }
    setDataModal({ ...order, listCombinedOrder, listCombinedDelivery })
    modalPaymentScreen.openModal()
  }
  const handleInvalidPayment = async (ref, _status, _combinedPaymentRef, eid) => {
    try {
      const r = confirm('Are you sure this is invalid payment?')
      if (r === true) {
        if (_combinedPaymentRef) {
          const _data = {
            combinedPaymentRef: _combinedPaymentRef,
            status: HOST_ORDER_UNPAID,
            placerStatus: BUYER_UNPAID,
          }
          await updateOrderCombinedPaymentAPI(_data)
        } else {
          dispatch(updateOrderStatus(eid, ref, _status, BUYER_UNPAID))
          await orderApi.updateOrderBuyerStatus(ref, { buyerStatus: BUYER_UNPAID })
          setTimeRender((prevState) => prevState + 1)
        }
       modalPaymentScreen.toggleModal()
      }
    } catch (error) {
      const { msgResp } = error
      addToast(msgResp, { appearance: 'error', autoDismiss: true })
      setTimeRender((prevState) => prevState + 1)
      modalPaymentScreen.toggleModal()
    }
  }

  const handleOpenWarning = (e, order) => {
    if (e && e.preventDefault) e.preventDefault()
    setDataModal(order)
    modalWarning.openModal()
  }

  const handleCancelOrder = async (e, ref, _status, _buyerStatus, _combinedPaymentRef) => {
    if (e && e.preventDefault) e.preventDefault()
    try {
      const orderEid = selectedDetailOrder?.eid || dataModal?.eid || data.find((o) => o.ref === ref)?.eid
      if (_status !== HOST_ORDER_CANCELED && _buyerStatus > BUYER_UNPAID) {
        if (_combinedPaymentRef) {
          const _data = {
            combinedPaymentRef: _combinedPaymentRef,
            status: HOST_ORDER_CANCELED,
            placerStatus: BUYER_REFUNDED,
          }
          await updateOrderCombinedPaymentAPI(_data)

          modalDetailOrder.closeModal()
          modalWarning.closeModal()
        } else {
          const _data = { status: HOST_ORDER_CANCELED, buyerStatus: BUYER_REFUNDED }
          await updateOrderStatusAndBuyerStatusAPI(ref, _data, orderEid)

          modalDetailOrder.closeModal()
          modalWarning.closeModal()
        }
      } else {
        const _data = { status: HOST_ORDER_CANCELED, _buyerStatus }
        await updateOrderStatusAPI(ref, _data, orderEid)

        modalDetailOrder.closeModal()
        modalWarning.closeModal()
      }
      if (setTimeRender) setTimeRender((prevState) => prevState + 1)
    } catch (error) {
      const { msgResp } = error
      addToast(msgResp || 'Failed to cancel order', { appearance: 'error', autoDismiss: true })
      modalDetailOrder.closeModal()
      modalWarning.closeModal()
    }
  }

  const handleShowRemindPayment = (e, order) => {
    e.preventDefault()
    setDataModalDetailOrder(order)
    modalRemindPayment.toggleModal()
  }

  const handleRowClick = (e, order) => {
    if (e?.target?.closest('select, input, button, .bell-btn, .paid, .paid-combined, a')) {
      return
    }
    setSelectedDetailOrder(order)
    modalDetailOrder.openModal()
  }

  function PurchaseColumn({ products, order }) {
    const [isExpanded, setIsExpanded] = useState(false)
    const visibleProducts = isExpanded ? products : products.slice(0, MAX_PREVIEW)

    return (
      <div>
        <div
          className='cursor-pointer'
          onClick={(e) => {
            e.stopPropagation()
            setSelectedDetailOrder(order)
            modalDetailOrder.openModal()
          }}
        >
          {visibleProducts.map((p, i) => (
            <div
              key={`${p.pid || 'no-pid'}-${i}`}
              className="purchase-product-item"
            >
              <p className="purchase-product-name">
                {p.pName} (qty:{p.pQuantity})
              </p>
              {p?.pSubItems?.length > 0 && (
                <ul className="purchase-subitems-list">
                  {p.pSubItems.map((item, idx) => (
                    <li key={item?.name || idx}>
                      {item?.name} x{item?.qty}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
        {products.length > MAX_PREVIEW && (
          <div
            className='text-underline cursor-pointer'
            style={{ fontSize: 14, color: '#51aaaa' }}
            onClick={(e) => {
              e.stopPropagation()
              setIsExpanded(v => !v)
            }}
          >
            {isExpanded ? 'Show less' : 'Show more'}
          </div>
        )}
      </div>
    )
  }

  const OrderRow = React.memo(({ order, index }) => {
    const isHitPay = order?.paymentType === PAYMENT_METHOD_HIT_PAY
    const isRefunded = order?.status === HOST_ORDER_REFUNDED
    const isDisabled = isUpdatingStatus || isRefunded

    return (
      <Row
        key={index}
        className={`${
          index % 2 !== 0 ? 'bg-light' : ''
        } list-event__item border-0 items-center p-3 m-0 od-clickable-row position-relative`}
        onClick={(e) => handleRowClick(e, order)}
      >
        {isHitPay && <HitPayRibbon style={{ width: 'fit-content' }}/>}
        <Col>
          <div
            className='od-row-name-cell'
            onClick={(e) => {
              e.stopPropagation()
              setSelectedDetailOrder(order)
              modalDetailOrder.openModal()
            }}
          >
            <span className='od-name-text' title={order.uName}>
              {order.uName}
            </span>
            {order?.comment && (
              <a
                href='#'
                className='ms-1'
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setDataModal(order)
                  modalMessage.openModal()
                }}
              >
                <i className='icon-new' />
              </a>
            )}
          </div>
        </Col>
        <Col>{order.uPhone}</Col>
        <Col>
          <Link
            to={`/event/detail?eid=${order.eid}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            {order.eTitle}
          </Link>
        </Col>
        <Col>
          <div>
            <p className='mb-1'>
              Closing: <br />
              {pagedEvents?.find((event) => event.id === order.eid)?.closingTimestamp
                ? moment.unix(pagedEvents.find((event) => event.id === order.eid).closingTimestamp).format('DD/MM/YYYY')
                : '-'}
            </p>
            <p className='mb-0'>
              Order date: <br />
              {order.createdAt ? moment.unix(order.createdAt).format('DD/MM/YYYY') : '-'}
            </p>
          </div>
        </Col>
        <Col>
          <PurchaseColumn products={order.allProductPerOrder} order={order} />
          {checkIsAmendOrder(order) && (
            <Link
              to={`/event/detail?eid=${order.eid}&&oid=${order.ref}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <span
                className='text-orange text-underline'
                style={{ fontSize: 14, marginTop: 3, display: 'inline-block' }}
              >
                Amend orders
              </span>
            </Link>
          )}
        </Col>
        <Col className='text-center'>
          {order.discountPerOrder > 0 ? (
            <span className='text-decoration-line-through' style={{ color: '#b8bbbe', marginRight: '4px' }}>
              ${formatNumberEng(order.totalPricePerOrder + order.adminCostPerOrder, 2)}
            </span>
          ) : null}
          ${formatNumberEng(order.totalFee, 2)}
          {order.buyerStatus === BUYER_REFUNDED ? <span className='ms-1' style={{ fontSize: '0.9em' }}>(Refunded)</span> : ''}
        </Col>
        <Col className='text-center'>
          {pagedEvents?.find((event) => event.id === order.eid)
            ?.closingTimestamp < now ? (
            <span>Closed</span>
          ) : (
            <span>Open</span>
          )}
        </Col>
        <Col className='text-center'>
          {order.buyerStatus === BUYER_UNPAID && (
            <button
              className='bell-btn'
              onClick={(e) => {
                e.stopPropagation()
                handleShowRemindPayment(e, order)
              }}
            >
              <FiBell style={{ fontSize: '20px' }} />
              <span>Not Paid</span>
            </button>
          )}

          {order.buyerStatus === BUYER_PAID && (
            <Link
              to='#'
              className={`${order?.combinedPaymentRef ? 'paid-combined' : 'paid'} mx-auto`}
              style={{ width: 'fit-content' }}
              data-toggle='modal'
              data-target='#modal-paid'
              onClick={(e) => {
                e.stopPropagation()
                openPaymentScreen(e, order)
              }}
            >
              <span>Paid</span>
            </Link>
          )}

          {order.buyerStatus === BUYER_CANCELED && <span className=''>Cancelled</span>}

          {order.buyerStatus === BUYER_COLLECTED && <span className=''>Collected</span>}

          {order.buyerStatus === BUYER_REFUNDED && <span className=''>Refunded</span>}
        </Col>
        <Col onClick={(e) => e.stopPropagation()}>
          <FormGroup>
            <Input
              id={`status-select-${order.ref}`}
              name={`status-select-${order.ref}`}
              type='select'
              className='form-control-payment'
              value={order.status}
              onClick={(e) => e.stopPropagation()}
              disabled={isDisabled}
              onChange={(e) =>
                onChangeSelect(
                  e,
                  order.ref,
                  order.status,
                  order.buyerStatus,
                  order.combinedPaymentRef,
                  order.eid,
                  order
                )
              }
              style={{
                ...(isRefunded
                  ? {
                      opacity: '0.5',
                      pointerEvents: 'none',
                      filter: 'grayscale(1)',
                    }
                  : { opacity: isUpdatingStatus ? 0.6 : 1 }),
                color:
                  order.status === HOST_ORDER_UNPAID || order.status === HOST_ORDER_SUBMITTED_UNPAID
                    ? '#ff6903'
                    : order.status === HOST_ORDER_VERIFIED || order.status === HOST_ORDER_SUBMITTED_VERIFIED
                    ? '#51aaaa'
                    : '#7c797a',
              }}
            >
              {!isHitPay && <option value={HOST_ORDER_CANCELED}>Cancelled</option>}
              {!isHitPay && <option value={HOST_ORDER_UNPAID}>Unpaid</option>}
              {!isHitPay && (
                <option value={HOST_ORDER_SUBMITTED_UNPAID}>Submitted & Unpaid</option>
              )}
              {(isHitPay || isRefunded) && (
                <option value={HOST_ORDER_REFUNDED}>
                  {isRefunded ? 'Refunded' : 'Refund'}
                </option>
              )}
              <option value={HOST_ORDER_SUBMITTED_VERIFIED}>Submitted & Verified</option>
              <option value={HOST_ORDER_SUBMITTED_COLLECTED}>Submitted & Collected</option>
              <option value={HOST_ORDER_VERIFIED}>Verified</option>
              <option value={HOST_ORDER_COLLECTED}>Collected</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>
    )
  })
  OrderRow.displayName = 'OrderRow'

  const ConsolidatedRow = React.memo(({ group, index }) => {
    const uName = Object.keys(group)[0]
    const orders = group[uName] || []
    const uPhone = orders[0]?.uPhone || ''
    const eventTitles = Array.from(new Set(orders.map(o => o.eTitle))).join(', ')

    // Group by pid and sum qty
    const aggregatedProducts = useMemo(() => {
      const m = new Map()
      for (const o of orders) {
        for (const item of (o.allProductPerOrder || [])) {
          const key = item.pid || item.pName
          const qty = Number(item.pQuantity) || 0
          if (m.has(key)) {
            m.get(key).qty += qty
          } else {
            m.set(key, { pid: item.pid, pName: item.pName, qty })
          }
        }
      }
      return Array.from(m.values())
    }, [orders])

    const [isShowingMoreProducts, setIsShowingMoreProducts] = useState(false)
    const rowKey = `${uName}-${orders[0]?.uid}`
    const isShowingDetails = expandedRows.has(rowKey)

    const visibleProducts = isShowingMoreProducts ? aggregatedProducts : aggregatedProducts.slice(0, MAX_PREVIEW)

    const totalPrice = orders.reduce((sum, o) => sum + (o.totalPricePerOrder || 0), 0)
    const consolidatedPaymentStatus = getConsolidatedPaymentStatus(orders)

    const toggleShowDetails = () => {
      setExpandedRows(prev => {
        const newSet = new Set(prev)
        if (newSet.has(rowKey)) {
          newSet.delete(rowKey)
        } else {
          newSet.add(rowKey)
        }
        return newSet
      })
    }

    return (
      <>
        <Row
          key={`consolidated-${uName}-${index}`}
          className={`${index % 2 !== 0 ? 'bg-light' : ''} list-event__item border-0 items-center p-3 m-0`}
        >
          <Col>
            <Link to={`/members/member-detail?gid=${groupId}&uid=${orders[0]?.uid}`} target="_blank" rel="noopener noreferrer">
              <p className='mb-1'>{uName}</p>
            </Link>
            <div
              className='d-flex align-items-center cursor-pointer mt-2'
              style={{ color: '#51aaaa', fontSize: '14px' }}
              onClick={toggleShowDetails}
            >
              {isShowingDetails ? <FaAngleUp size={16} /> : <FaAngleDown size={16} />}
              <span className='ms-1'>Show details</span>
            </div>
          </Col>
          <Col>
            <p className='mb-1'>{uPhone}</p>
          </Col>
          <Col>{eventTitles}</Col>
          <Col>
            {visibleProducts.map((p, i) => (
              <p key={p.pid || `${p.pName}-${i}`} className={i === visibleProducts.length - 1 ? 'mb-2' : ''}>
                {p.pName} (qty:{p.qty})
              </p>
            ))}
            {aggregatedProducts.length > MAX_PREVIEW && (
              <div
                className='text-underline cursor-pointer'
                style={{ fontSize: 14, color: '#51aaaa' }}
                onClick={() => setIsShowingMoreProducts(!isShowingMoreProducts)}
              >
                {isShowingMoreProducts ? 'Show less' : 'Show more'}
              </div>
            )}
          </Col>
          <Col className='text-center'>
            ${formatNumberEng(totalPrice, 2)}
          </Col>
          <Col className='text-center'>
            <span
              style={{
                color: consolidatedPaymentStatus.includes('Not Paid')
                  ? '#ff6903'
                  : consolidatedPaymentStatus === 'Paid'
                    ? '#7c797a'
                    : '#15cdcb',
                fontWeight: 600
              }}
            >
              {consolidatedPaymentStatus}
            </span>
          </Col>
        </Row>

        {isShowingDetails && orders.map((order, orderIdx) => {
          const isHitPay = order?.paymentType === PAYMENT_METHOD_HIT_PAY
          const isRefunded = order?.status === HOST_ORDER_REFUNDED
          const isDisabled = isUpdatingStatus || isRefunded

          return (
            <Row
              key={`detail-${order.ref}-${orderIdx}`}
              className={`${index % 2 !== 0 ? 'bg-light' : ''} list-event__item border-0 items-center p-3 m-0 position-relative`}
              style={orderIdx === 0 ? { borderTop: '1px solid rgba(223,225,228, 0.9)', paddingTop: 10 } : {}}
            >
              {isHitPay && <HitPayRibbon style={{ width: 'fit-content' }} />}
              <Col>

              </Col>
              <Col>

              </Col>
              <Col>
                <Link to={`/event/detail?eid=${order.eid}`} target="_blank" rel="noopener noreferrer">
                  {order.eTitle}
                </Link>
              </Col>
              <Col>
                {order.allProductPerOrder.map((p, i) => (
                  <p key={`${p.pid || p.pName}-${i}`} className='mb-1 truncate-text'>
                    {p.pName} (qty: {p.pQuantity})
                  </p>
                ))}
              </Col>
              <Col className='text-center'>
                ${formatNumberEng(order.totalPricePerOrder, 2)}
              </Col>
              <Col className='text-center'>
                <FormGroup className='d-flex justify-content-center mb-0'>
                  <Input
                    id={`status-select-${order.ref}`}
                    name={`status-select-${order.ref}`}
                    type='select'
                    className='form-control-payment'
                    value={order.status}
                    disabled={isDisabled}
                    onChange={(e) =>
                      onChangeSelect(
                        e,
                        order.ref,
                        order.status,
                        order.buyerStatus,
                        order.combinedPaymentRef,
                        order.eid,
                        order
                      )
                    }
                    style={{
                      color:
                        order.status === HOST_ORDER_UNPAID || order.status === HOST_ORDER_SUBMITTED_UNPAID
                          ? '#ff6903'
                          : order.status === HOST_ORDER_VERIFIED || order.status === HOST_ORDER_SUBMITTED_VERIFIED
                          ? '#51aaaa'
                          : '#7c797a',
                      width: '160px',
                      ...(isRefunded
                        ? {
                            opacity: '0.5',
                            pointerEvents: 'none',
                            filter: 'grayscale(1)',
                          }
                        : { opacity: isUpdatingStatus ? 0.6 : 1 }),
                    }}
                  >
                    {!isHitPay && <option value={HOST_ORDER_CANCELED}>Cancelled</option>}
                    {!isHitPay && <option value={HOST_ORDER_UNPAID}>Unpaid</option>}
                    {!isHitPay && (
                      <option value={HOST_ORDER_SUBMITTED_UNPAID}>Submitted & Unpaid</option>
                    )}
                    {(isHitPay || isRefunded) && (
                      <option value={HOST_ORDER_REFUNDED}>
                        {isRefunded ? 'Refunded' : 'Refund'}
                      </option>
                    )}
                    <option value={HOST_ORDER_SUBMITTED_VERIFIED}>Submitted & Verified</option>
                    <option value={HOST_ORDER_SUBMITTED_COLLECTED}>Submitted & Collected</option>
                    <option value={HOST_ORDER_VERIFIED}>Verified</option>
                    <option value={HOST_ORDER_COLLECTED}>Collected</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          )
        })}
      </>
    )
  })
  ConsolidatedRow.displayName = 'ConsolidatedRow'

  return (
    <div className='list-event'>
      {isUpdatingStatus && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.35)',
            zIndex: 1050,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <div className='p-4 rounded d-flex align-items-center'>
            <div className='spinner-border text-primary me-3' role='status' aria-hidden='true' />
          </div>
        </div>
      )}
      <React.Fragment>
        <div style={{ top: 0, backgroundColor: 'white' }}>
          {!isConsolidate && (
            <div className='d-flex align-items-center justify-content-between mb-2' style={{ gap: '1rem' }}>
              <div className='d-flex align-items-center' style={{ gap: '1rem' }}>
                <Tabs value={orderTab} onValueChange={setOrderTab}>
                  <TabsList>
                    <TabsTrigger value="all">
                      All
                    </TabsTrigger>
                    <TabsTrigger value="unpaid">
                      Unpaid Orders
                    </TabsTrigger>
                  </TabsList>
                </Tabs>
                <div className='d-flex align-items-center' style={{ marginLeft: '1.5rem' }}>
                  <input
                    type='checkbox'
                    id='exclude-cancelled-checkbox'
                    checked={excludeCancelled}
                    onChange={(e) => setExcludeCancelled(e.target.checked)}
                    style={{
                      cursor: 'pointer',
                      margin: 0,
                      marginRight: '0.5rem',
                      width: '16px',
                      height: '16px',
                      accentColor: '#009A97'
                    }}
                  />
                  <label
                    htmlFor='exclude-cancelled-checkbox'
                    style={{ cursor: 'pointer', marginBottom: 0, userSelect: 'none', whiteSpace: 'nowrap' }}
                  >
                    Exclude cancelled orders
                  </label>
                </div>
              </div>
              {selectedOrders.length > 0 && (
                <span className='fw-bold' style={{ fontSize: '14px', whiteSpace: 'nowrap', flexShrink: 0 }}>
                  {selectedOrders.length} orders selected (Status: {getStatusText(selectedOrders[0].status)}) - Change status using any dropdown to update all selected orders
                </span>
              )}
            </div>
          )}
        </div>

        <TableHeaderWithSort
          headers={tableHeaders}
          onSorting={(field, order, type) => setSorting({ field, order, type })}
          defaultSortingField='eOrderNo'
          defaultSortingOrder='asc'
          className={'row mx-0 p-3 bg-light fw-bold'}
          key='table-header'
        />

        {loading ? <div>Loading...</div> : null}
        {!loading && (isConsolidate
          ? (groupedOrdersByUName.length > 0
              ? groupedOrdersByUName.map((group, index) => (
                  <ConsolidatedRow key={Object.keys(group)[0] || index} group={group} index={index} />
                ))
              : null)
          : (data.length > 0
              ? data.map((order, index) => (
                  <OrderRow key={order.ref} order={order} index={index} />
                ))
              : null)
        )}
      </React.Fragment>
      {Object.keys(dataModal).length !== 0 && (
        <ModalMessage data={dataModal} modalMessage={modalMessage.isOpen} toggleMessage={modalMessage.toggleModal} />
      )}
      {Object.keys(dataModal).length !== 0 && (
        <ModalPaymentScreen
          data={dataModal}
          modalPaymentScreen={modalPaymentScreen.isOpen}
          togglePaymentScreen={modalPaymentScreen.toggleModal}
          handleInvalidPayment={handleInvalidPayment}
        />
      )}
      {Object.keys(dataModal).length !== 0 && (
        <ModalWarning
          data={dataModal}
          modalWarning={modalWarning.isOpen}
          toggleWarning={modalWarning.toggleModal}
          handleCancel={handleCancelOrder}
        />
      )}
      {/* Order Detail Modal */}
      {selectedDetailOrder && (
        <ModalDetailOrder
          id={selectedDetailOrder.eid}
          order={selectedDetailOrder}
          modalDetailOrder={modalDetailOrder.isOpen}
          toggleDetailOrder={modalDetailOrder.toggleModal}
          handleOpenWarning={handleOpenWarning}
          setTimeRender={setTimeRender}
          products={
            eventAndOrderById?.find((event) => event.id === selectedDetailOrder.eid)?.products ||
            pagedEvents?.find((event) => event.id === selectedDetailOrder.eid)?.products ||
            []
          }
        />
      )}
      {dataModalDetailOrder && modalRemindPayment.isOpen && (
        <RemindPaymentModel
          order={dataModalDetailOrder}
          modalRemindPayment={modalRemindPayment.isOpen}
          host={host}
          remindMessage={remindMessage}
          toggleDetailOrder={modalRemindPayment.toggleModal}
        />
      )}
      {/* Refund Order Modal */}
      <ModalRefundOrder
        modalRefundOrder={modalRefundOrder.isOpen}
        toggleRefundOrder={modalRefundOrder.toggleModal}
        data={selectedRefundOrder || {}}
        onConfirmRefund={handleConfirmRefund}
        products={productList || []}
      />
    </div>
  )
}

export default OrderList
